import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    layout: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        padding: '50px',
        gap: '60px',
        justifyContent: 'center',
        alignItems: 'flex-start',
        [theme.breakpoints.down('lg')]: {
            padding: '20px',
        },
    }),

    leftSide: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        [theme.breakpoints.up('lg')]: {
            maxWidth: '710px',
            gap: '40px',
        },
    }),

    rightSide: css({
        position: 'sticky',
        top: '60px',
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            width: '360px',
            minWidth: '360px',
        },
    }),

    paymentPlanWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        ...(isHosTheme && { gap: '10px' }),
    }),

    overviewPayment: css({
        border: `1px solid ${theme.palette.grey[600]}`,
        padding: '7px 20px 20px 20px',

        ...(isHosTheme && {
            border: 'none',
            padding: '0px',
        }),
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        borderRadius: '100px',
        width: '100%',
        alignSelf: 'stretch',
        marginTop: '30px',
        textTransform: 'uppercase',
    }),
};
